// import React, { useState, useEffect, useRef } from 'react';
// import data from '../../femcare-content.json';

// const { patientJourney } = data.sections;

// /* ── Per-step card background colors & number tint colors ── */
// const CARD_STYLES = [
//   {
//     bg: '#fce4ec',          // soft pink
//     numColor: '#f5b0c7',    // deeper pink tint for the big number
//   },
//   {
//     bg: '#e0f7fa',          // soft cyan / light blue
//     numColor: '#80deea',
//   },
//   {
//     bg: '#ede7f6',          // soft lavender / purple
//     numColor: '#b39ddb',
//   },
//   /* Extend if you have more steps */
//   {
//     bg: '#e8f5e9',
//     numColor: '#a5d6a7',
//   },
//   {
//     bg: '#fff8e1',
//     numColor: '#ffe082',
//   },
//   {
//     bg: '#fce4ec',
//     numColor: '#f48fb1',
//   },
// ];

// const PatientJourney = () => {
//   const { id, heading, subheading, steps } = patientJourney;
//   const [visibleItems, setVisibleItems] = useState([]);
//   const itemRefs = useRef([]);

//   useEffect(() => {
//     const timeout = setTimeout(() => {
//       const observers = itemRefs.current.map((ref, index) => {
//         if (!ref) return null;

//         const observer = new IntersectionObserver(
//           (entries) => {
//             entries.forEach((entry) => {
//               if (entry.isIntersecting) {
//                 setTimeout(() => {
//                   setVisibleItems((prev) =>
//                     prev.includes(index) ? prev : [...prev, index]
//                   );
//                 }, index * 150);
//                 observer.unobserve(entry.target);
//               }
//             });
//           },
//           { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
//         );

//         observer.observe(ref);
//         return observer;
//       });

//       return () => observers.forEach((o) => o && o.disconnect());
//     }, 100);

//     return () => clearTimeout(timeout);
//   }, []);

//   return (
//     <section id={id} className="w-full bg-white py-12 md:py-16 lg:py-20">
//       <div className="container mx-auto px-4 md:px-8">

//         {/* ── Heading ── */}
//         {heading && (
//           <h2
//             className="text-center font-bold mb-10 md:mb-14 primary-text"
//             style={{ fontSize: 'clamp(1.3rem, 2.8vw, 2rem)' }}
//           >
//             {heading}
//           </h2>
//         )}

//         {/* ── Card Grid ── */}
//         <div
//           className="grid gap-4 md:gap-6"
//           style={{
//             gridTemplateColumns: `repeat(${steps.length}, 1fr)`,
//             maxWidth: '1100px',
//             margin: '0 auto',
//           }}
//         >
//           {steps.map((step, index) => {
//             const isVisible = visibleItems.includes(index);
//             const cardStyle = CARD_STYLES[index % CARD_STYLES.length];

//             /* Format step number: 1 → "01", 2 → "02" … */
//             const stepNum =
//               typeof step.step === 'number'
//                 ? String(step.step).padStart(2, '0')
//                 : step.step;

//             return (
//               <div
//                 key={step.id}
//                 ref={(el) => (itemRefs.current[index] = el)}
//                 className="relative rounded-2xl overflow-hidden flex flex-col"
//                 style={{
//                   backgroundColor: cardStyle.bg,
//                   minHeight: '240px',
//                   padding: '1.5rem 1.5rem 0',
//                   opacity: isVisible ? 1 : 0,
//                   transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
//                   transition: 'opacity 0.6s ease, transform 0.6s ease',
//                 }}
//               >
//                 {/* ── Title ── */}
//                 <h3
//                   className="font-bold leading-snug primary-text mb-3"
//                   style={{ fontSize: 'clamp(1rem, 1.6vw, 1.2rem)' }}
//                 >
//                   {step.title}
//                 </h3>

//                 {/* ── Description ── */}
//                 <p
//                   className="primary-text leading-relaxed"
//                   style={{
//                     fontSize: 'clamp(0.82rem, 1.3vw, 0.95rem)',
//                     flex: 1,
//                   }}
//                   /* Render inline bold tags if description contains <b> / <strong> */
//                   dangerouslySetInnerHTML={{ __html: step.description }}
//                 />

//                 {/* ── Giant Step Number (decorative) ── */}
//                 <div
//                   aria-hidden="true"
//                   className="select-none font-black leading-none"
//                   style={{
//                     fontSize: 'clamp(5rem, 10vw, 7.5rem)',
//                     color: cardStyle.numColor,
//                     lineHeight: 0.85,
//                     marginTop: '0.5rem',
//                     /* Slight bleed off the bottom edge for the cropped look */
//                     marginBottom: '-0.15em',
//                     letterSpacing: '-0.03em',
//                   }}
//                 >
//                   {stepNum}
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         {/* ── Bottom subheading ── */}
//         {subheading && (
//           <p
//             className="text-center text-sm md:text-base primary-text"
//             style={{ maxWidth: '640px', margin: '3rem auto 0' }}
//           >
//             {subheading}
//           </p>
//         )}
//       </div>
//     </section>
//   );
// };

// export default PatientJourney;

import React, { useState, useEffect, useRef } from 'react';
import data from '../../femcare-content.json';
import TalkToCareGuideButton from '../whatsapp/whatsappIntegration';

const { patientJourney } = data.sections;

/* ── Per-step card background colors & number tint colors ── */
const CARD_STYLES = [
  { bg: '#fce4ec', numColor: '#f8bfd3' },
  { bg: '#e0f7fa', numColor: '#b7f3fd' },
  { bg: '#ede7f6', numColor: '#e4d6ff' },
  { bg: '#e8f5e9', numColor: '#c6dcc7' },
  { bg: '#fff8e1', numColor: '#ffe082' },
  { bg: '#fce4ec', numColor: '#f48fb1' },
];

const PatientJourney = () => {
  const { id, heading, subheading, steps, cta } = patientJourney;
  const [visibleItems, setVisibleItems] = useState([]);
  const itemRefs = useRef([]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const observers = itemRefs.current.map((ref, index) => {
        if (!ref) return null;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                setTimeout(() => {
                  setVisibleItems((prev) =>
                    prev.includes(index) ? prev : [...prev, index]
                  );
                }, index * 150);
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
        );

        observer.observe(ref);
        return observer;
      });

      return () => observers.forEach((o) => o && o.disconnect());
    }, 100);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <section id={id} className="w-full bg-white ava-section-gap pb-10  md:pb-14 lg:pb-18">
      <div className="container mx-auto px-4 md:px-8 ">

        {/* ── Heading ── */}
        {heading && (
          <h2
            className="text-center ava-heading-lg  ava-heading-gap"
            // style={{ fontSize: 'clamp(1.3rem, 2.8vw, 2rem)' }}
          >
            {heading}
          </h2>
        )}

        {/*
          ── Responsive grid ──────────────────────────────────────────
             Mobile  (<640px) : 1 card per row
             Tablet  (≥640px) : 2 cards per row
             Desktop (≥1024px): all steps in a single row
        ─────────────────────────────────────────────────────────────── */}
        <style>{`
          .pj-grid {
            display: grid;
           
            grid-template-columns: repeat(1, 1fr);
            max-width: 1100px;
            margin: 0 auto;
          }
          @media (min-width: 640px) {
            .pj-grid { grid-template-columns: repeat(2, 1fr); }
          }
          @media (min-width: 1024px) {
            .pj-grid { grid-template-columns: repeat(${steps.length}, 1fr);  }
          }
        `}</style>

        {/* ── Card Grid ── */}
        <div className="pj-grid ava-card-gap">
          {steps.map((step, index) => {
            const isVisible = visibleItems.includes(index);
            const cardStyle = CARD_STYLES[index % CARD_STYLES.length];

            /* Format step number: 1 → "01", 2 → "02" … */
            const stepNum =
              typeof step.step === 'number'
                ? String(step.step).padStart(2, '0')
                : step.step;

            return (
              <div
                key={step.id}
                ref={(el) => (itemRefs.current[index] = el)}
                className="relative ava-radius-md overflow-hidden flex flex-col"
                style={{
                  backgroundColor: cardStyle.bg,
                  minHeight: '240px',
                  padding: '1.5rem 1.5rem 0',
                  opacity: isVisible ? 1 : 0,
                  transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
                  transition: 'opacity 0.6s ease, transform 0.6s ease',
                }}
              >
                {/* ── Title ── */}
                <h3
                  className="ava-text-subheading  mb-3"
                  // style={{ fontSize: 'clamp(1rem, 1.6vw, 1.2rem)' }}
                >
                  {step.title}
                </h3>

                {/* ── Description ── */}
                <p
                  className=" ava-text-body "
                  style={{
                    // fontSize: 'clamp(0.82rem, 1.3vw, 0.95rem)',
                    flex: 1,
                  }}
                  dangerouslySetInnerHTML={{ __html: step.description }}
                />

                {/* ── Giant Step Number (decorative) ── */}
                <div
                  aria-hidden="true"
                  className="select-none font-black  "
                  style={{
                    fontSize: 'clamp(5rem, 10vw, 7.5rem)',
                    color: cardStyle.numColor,
                    lineHeight: 0.85,
                    marginTop: '0.5rem',
                    marginBottom: '-0.15em',
                    letterSpacing: '-0.03em',
                  }}
                >
                  {stepNum}
                </div>
              </div>
            );
          })}
        </div>

        {/* ── Bottom subheading ── */}
        {subheading && (
          <p
            className="text-center ava-text-body "
            style={{ maxWidth: '640px', margin: '2rem auto 0' }}
          >
            {subheading}
          </p>
        )}

        {cta && (
          <div className="flex justify-center mt-2 md:mt-4 gap-3 flex-wrap">
            <TalkToCareGuideButton className='btn-transparent'/>
            <a
              href={cta.href}
              className="btn-primary"
            >
              {cta.label}
            </a>
          </div>
        )}

      </div>
    </section>
  );
};

export default PatientJourney;